import { UploadingVideo } from "./components";

export const UploadVideo = () => {
  return <UploadingVideo />;
};
